// Log a maintenance entry. Informational only — does NOT change operational_status (acceptance #14).

import React, { useState } from 'react';
import { buttonClass } from '../components/ui/Button';
import { Dialog } from '../components/ui/Dialog';
import { FieldRow, TextArea } from '../components/ui/Field';
import { useApi } from '../apiHelpers';
import { useToast } from '../components/Toast/ToastContext';

interface Props {
  assetId: string;
  onClose: () => void;
  onSuccess: () => void;
}

const LogMaintenanceModal: React.FC<Props> = ({ assetId, onClose, onSuccess }) => {
  const api = useApi();
  const toast = useToast();
  const [descript, setDescript] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async () => {
    if (!descript.trim()) { toast.error('Description is required'); return; }
    setSubmitting(true);
    try {
      await api.post(`/assets/${assetId}/maintenance`, {
        body: { descript: descript.trim() },
      });
      toast.success('Maintenance logged');
      onSuccess();
    } catch {
      toast.error('Failed to log maintenance');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog
      open
      onClose={onClose}
      dirty={descript.trim() !== ''}
      title="Log Maintenance"
      meta="Informational entry, does not change status"
      size="md"
      footer={
        <>
          <button onClick={onClose} className={buttonClass('quiet', 'md')}>Cancel</button>
          <button
            onClick={handleSubmit}
            disabled={submitting}
            className={buttonClass('filled', 'md')}
          >
            {submitting ? 'Logging…' : 'Log Entry'}
          </button>
        </>
      }
    >
      <FieldRow label="Description">
        <TextArea
          autoFocus
          value={descript}
          onChange={e => setDescript(e.target.value)}
          rows={4}
          placeholder="What was done?"
          className="!resize-none"
        />
      </FieldRow>
    </Dialog>
  );
};

export default LogMaintenanceModal;
